import React from 'react';
import { useNavigate } from 'react-router-dom';

export const PageNotFound = () => {
  const navigate = useNavigate();

  const handleClickHome = () => {
    navigate("/");
  };

  return (
    <>
      <div className="flex items-center my-20">
          <div className="w-full pt-10 flex flex-col items-center justify-center">
              {/* The status code was an `h2` and the sentence beside it was a `p`, so
                  the page's own name was neither. One `h1` now carries both -- it
                  reads as "404. Không Tìm Thấy Trang" -- and the spans keep the
                  two type sizes, so the page looks exactly as it did. */}
              <h1 className="flex flex-col items-center">
                  <span className="text-[80px] font-bold text-primary">404</span>
                  <span className="text-[40px] font-medium text-primary">Không Tìm Thấy Trang</span>
              </h1>
              <p className='text-base'>Vui lòng liên hệ admin</p>
              <div>
                  <button 
                  type='button'
                  onClick={() => handleClickHome()}
                  className="table-primary-btn w-[200px] h-11 mt-5
                  focus:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-1"
                  >Vể trang chủ</button>
              </div>
          </div>
      </div>
    </>
  );
};
